import React from "react";
import BaseButton from "./BaseButton";
import carImage from "../assets/pictures/client-in-car.webp"
import { useNavigate } from 'react-router-dom';
import {useAuth} from "../context/AuthContext";

function PassengerCommercial() {
    const navigate = useNavigate();
    const { user } = useAuth();

    return (
        <div className="driver-commercial-container">
            <img src={carImage} alt="" />
            <div className="text-block">
                <div className="subheading">IŠSIKVIESKITE ETRANSPORT</div>
                <h1 className="heading">KELIOS MINUTĖS IR JŪS KELYJE</h1>
                <p className="description">
                    Etransport vairuotojai pasiruošę pavežti jus laiku ir su šypsena.
                </p>
                <div className="buttons">
                    {!user && (
                        <BaseButton
                            className={"baseButton--primary"}
                            text={"PRISIJUNGTI"}
                            handleOnClick={() => navigate('/login')}
                        />
                    )}
                    {user && (
                        <BaseButton
                            className={"baseButton--primary"}
                            text={"Užsisakyti"}
                            handleOnClick={() => navigate('/order')}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default PassengerCommercial;